import React from 'react';
import { motion } from 'framer-motion';

interface HeaderProps {
  headingControls: any;
  textControls: any;
}

/**
 * Header component for the notifications page
 */
const Header = React.memo(({ headingControls, textControls }: HeaderProps) => {
  return (
    <>
      <div className="mx-auto w-full max-w-3xl">
        <motion.div animate={headingControls} initial={{ opacity: 0, y: 20 }}>
          <h1 className="text-2xl sm:text-3xl font-bold text-center text-gray-900">
            Get the Fantasy Edge
          </h1>
        </motion.div>
      </div>

      <div className="mt-3 sm:mt-4 mx-auto w-full max-w-3xl">
        <motion.div animate={textControls} initial={{ opacity: 0, y: 20 }}>
          <p className="text-sm sm:text-base text-center text-gray-600 leading-relaxed">
            Stay ahead of your rivals. Win your mini-leagues.
          </p>
        </motion.div>
      </div>
    </>
  );
});

Header.displayName = 'Header';

export default Header;
